export default __webpack_public_path__ + "09778de.png";